import { useEffect, useState } from "react";

// Client functions
import { updateReadTranscript } from "sj-ui-toolkit/src/api";
import { getLessonTranscriptUrl } from "sj-ui-toolkit/src/client";

const TextViewer = ({ lessonId, readTranscript }) => {
  const [transcriptUrl, setTranscriptUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTranscript = async () => {
      setLoading(true);
      try {
        const url = await getLessonTranscriptUrl({ lessonId });
        setTranscriptUrl(url);
      } catch (error) {
        console.error("Error fetching transcript URL:", error);
      }
      setLoading(false);
    };

    if (lessonId && !transcriptUrl) {
      fetchTranscript();
    }
  }, [lessonId]);

  useEffect(() => {
    const handleMessage = async event => {
      if (!readTranscript && event.data === "reachedEnd") {
        const result = await updateReadTranscript({ lessonId });
        if (!result) {
          console.error("Failed to send read transcript event");
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [lessonId]);

  if (loading) return <div>Loading transcript...</div>;

  return <iframe src={transcriptUrl} title="Transcript" />;
};

export default TextViewer;
